import api from './api';

const websiteSettingsService = {
  getSettings: async () => {
    const response = await api.get('/admin/website-settings');
    return response.data;
  },

  updateSettings: async (data) => {
    const response = await api.put('/admin/website-settings', data);
    return response.data;
  },

  // One image for the editable site content -> { url }
  uploadImage: async (file) => {
    const formData = new FormData();
    formData.append('file', file);
    const response = await api.post('/admin/website-settings/images', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },

  // "Commande sur mesure" requests sent from the website contact section
  getCustomOrderRequests: async () => {
    const response = await api.get('/admin/custom-order-requests');
    return response.data;
  },

  updateCustomOrderRequestStatus: async (id, status) => {
    const response = await api.patch(`/admin/custom-order-requests/${id}/status`, { status });
    return response.data;
  },
};

export default websiteSettingsService;
